import { assetIsImage, getFiletypeIcon } from '../../../helpers/assets';
import AzureBlob from '../../common/AzureBlob.react';
var Asset = function Asset(_ref) {
  var type = _ref.type,
    contentType = _ref.contentType,
    lowRes = _ref.lowRes,
    filename = _ref.filename;
  if (assetIsImage[type]) return /*#__PURE__*/React.createElement("div", {
    className: "asset__image"
  }, /*#__PURE__*/React.createElement(AzureBlob, {
    filename: "".concat(lowRes || filename)
  }));
  return /*#__PURE__*/React.createElement("div", {
    className: "asset__icon"
  }, /*#__PURE__*/React.createElement("img", {
    src: getFiletypeIcon(contentType),
    alt: "filetype"
  }));
};
export default Asset;